import { Select } from "@mantine/core";
import type { SiteName } from "../../../../../utils/enums";
import {
  DUMMY_DEFINED_FILTER_ID_FOR_NEW_FILTERS,
  type EdaFilter
} from "../EnergyDataAcquisitionSelectionModal";

declare const SITE_NAME: SiteName;

interface DefinedFilterDropdownProps {
  definedFilters: Array<EdaFilter>;
  definedFilterId: number | null;
  savingDefinedFilters: boolean;
  onChange: (filterId: number) => void;
}

function DefinedFilterDropdown({
  definedFilters,
  definedFilterId,
  savingDefinedFilters,
  onChange
}: DefinedFilterDropdownProps) {
  const selectedFilter = definedFilters.find(
    (filter) => filter.id === definedFilterId
  );

  const groupedDefinedFilters = definedFilters.reduce<{
    allProjects: Array<EdaFilter>;
    userDefined: Array<EdaFilter>;
  }>(
    (accumulator, definedFilter) => {
      if (definedFilter.availableInAllProjects) {
        accumulator.allProjects.push(definedFilter);
      } else {
        accumulator.userDefined.push(definedFilter);
      }

      return accumulator;
    },
    { allProjects: [], userDefined: [] }
  );

  const newFilter = {
    value: DUMMY_DEFINED_FILTER_ID_FOR_NEW_FILTERS.toString(),
    label: "Neuen Filter erstellen"
  };
  const allProjectsFilters = {
    group: SITE_NAME,
    items: groupedDefinedFilters.allProjects.map((filter) => ({
      value: filter.id.toString(),
      label: filter.filterName
    }))
  };
  const userDefinedFilters = {
    group: "Nutzerdefiniert",
    items: groupedDefinedFilters.userDefined.map((filter) => ({
      value: filter.id.toString(),
      label: filter.filterName
    }))
  };

  return (
    <Select
      className="DefinedFilterDropdown"
      data={[newFilter, allProjectsFilters, userDefinedFilters]}
      disabled={savingDefinedFilters}
      placeholder="Definierten Filter auswählen"
      value={selectedFilter?.id.toString()}
      w="fit-content"
      onChange={(value) => onChange(Number(value))}
    />
  );
}

export { DefinedFilterDropdown };
